import React, { PropTypes } from 'react'
import moment from 'moment'
import { DATE_FORMAT } from '../../constants'
import classnames from 'classnames'

moment.locale('fr')

export default function Base(props) {
	let cls = classnames(props.className, {
		[`category-${props.catSlug}`]: props.catSlug,
		'article-tease--no-image': !props.thumbnail,
		'article-tease--termname': props.displayTerm,
	})

	// let img = null
	let vid = props.video
		? <div className="article-tease__vid" />
		: null

	let img = props.thumbnail
		? <div className='article-tease__image'>
				<img className='img-responsive-grow' src={ props.thumbnail } alt={ props.chapo }/>
				{ vid }
				<div className="article-tease__image-hover" />
			</div>
		: null

	// let cls = props.className

	let term = props.displayTerm
		? <div className="article-tease__display-term"><div>{ props.displayTerm }</div></div>
		: null

	// if (props.catSlug) {
	// 	cls += ` category-${props.catSlug}`
	// }

	// Handle no-image case
	// if (props.thumbnail) {
	// 	img = <div className='article-tease__image'>
	// 		<img className='img-responsive-grow' src={ props.thumbnail } alt={ props.chapo }/>
	// 		{ vid }
	// 		<div className="article-tease__image-hover" />
	// 	</div>

	// // Special case used for presse teasers
	// // We show the image div, but don't have an image
	// } else if (props.thumbnail === false) {
	// 	img = <div className='article-tease__image'>
	// 		{ vid }
	// 		<div className="article-tease__image-hover" />
	// 	</div>
	// 	cls += ' article-tease--no-image'

	// } else {
	// 	cls += ' article-tease--no-image'

	// }

	return <a className={ cls } href={ props.permalink } target={ props.target }>
		{ img }
		{ term }
		<div className='article-tease__readmore'>Lire la suite</div>
		<div className='article-tease__content'>
			{ props.showDate ? <div className="article-tease__date">{ moment(props.post_date).format(DATE_FORMAT) }</div> : null }
			<h2 className='article-tease__title'>{ props.post_title }</h2>
			<div className='article-tease__body' dangerouslySetInnerHTML={{ __html: props.chapo }} />
		</div>
	</a>
}


Base.propTypes = {
	// Formatting
	showDate: PropTypes.bool.isRequired,
	className: PropTypes.string.isRequired,

	// Post (wp provided)
	permalink: PropTypes.string.isRequired,
	imageLink: PropTypes.string,
	thumbnail: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	post_title: PropTypes.string.isRequired,
	chapo: PropTypes.string,
	target: PropTypes.oneOf(['__blank']),
	video: PropTypes.bool.isRequired,
	displayTerm: PropTypes.string,
	catSlug: PropTypes.string,
}

Base.defaultProps = {
	showDate: false,
	className: 'article-tease article-tease--tall article-tease je-minforme--default',
	video: false,
}

//export const Normal = Base

export function NormalWide (props) {
	return <Base className='article-tease article-tease--wide' { ...props } />
}

function Actualite(props) {
	return <Base { ...props } className='article-tease article-tease--tall article-tease--actualite' />
}

function ActualiteWide(props) {
	return <Base { ...props } className='article-tease article-tease--wide article-tease--actualite' />
}

Actualite.defaultProps = ActualiteWide.defaultProps = {
	showDate: true,
}

export function Statistique(props) {
	return <Base { ...props } className={`article-tease article-tease--${props.format} article-tease--stat`} />
}

export function FichePratique(props) {
	return <Base { ...props } className={`article-tease article-tease--${props.format} article-tease--fp`} />
}

Statistique.defaultProps = FichePratique.defaultProps = {
	format: 'tall',
}

Statistique.propTypes = FichePratique.propTypes = {
	format: PropTypes.oneOf(['wide', 'tall']),
}


export {
	Base as Normal,
	Actualite,
	ActualiteWide,
}



// WEBPACK FOOTER //
// ./js/website/react_components/teasers/Base.js